module.exports = __webpack_public_path__ + "img/quick-books-btn-default.c072cd3f.svg";